import type { Locales, UserCustomAttribute } from 'shared-types';

type Params =
  | {
      ignoreLabelTranslations?: never;
      language: Locales;
      optionGroups: UserCustomAttribute['optionGroups'];
    }
  | {
      ignoreLabelTranslations: true;
      language?: never;
      optionGroups: UserCustomAttribute['optionGroups'];
    };

const getMergedOptionGroupOptions = ({
  ignoreLabelTranslations,
  language,
  optionGroups
}: Params) => {
  const options: { key: string; label: string }[] = [];

  const keys: { [key: string]: true } = {};

  optionGroups?.forEach((optionGroup) => {
    optionGroup.options.forEach((option) => {
      if (!keys[option.key]) {
        keys[option.key] = true;
        options.push({
          key: option.key,
          label: ignoreLabelTranslations
            ? option.label
            : option.labelTranslations?.[language] || option.label
        });
      }
    });
  });

  if (optionGroups?.[0].sort === 'alphabetical') {
    options.sort((a, b) =>
      a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1
    );
  }

  return options;
};

export default getMergedOptionGroupOptions;
